import React, { FC, useCallback, useState } from 'react';
import { Button, Form, message, Modal, Select } from 'antd';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import {
	siteSurveyTemplatesRestCrudThunksForBuyer,
	siteSurveyTemplatesRestCrudThunksForSupplier,
} from '../../thunks/site_survey_templates_thunks';
import { getRecordsForCompositeTargetCollection } from '../../reducers/standard_reducer_utils';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const FORM_NAME = 'task-entity-form';
const WO_TASK_COLLECTION = 'woTasksCollection';

const PMTemplateTaskEntityAssociateModal: FC<any> = ({
	task,
	onCancel,
	siteSurveyTemplates,
	getSiteSurveyTemplates,
	onSave,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const getSelectedSSTemplates = useCallback(
		(values) => {
			const records = getRecordsForCompositeTargetCollection(
				siteSurveyTemplates,
				WO_TASK_COLLECTION
			);
			return nullSafeGetOrElse('siteSurveyTemplateIds', values, [])
				.map((id) => records.find((_) => _.id === id))
				.filter((_) => !!_);
		},
		[siteSurveyTemplates]
	);

	const onSubmit = useCallback(
		(values) => {
			setSaving(true);
			onSave({
				...task,
				...values,
				siteSurveyTemplates: getSelectedSSTemplates(values),
			})
				.then(() => {
					onCancel();
				})
				.catch(message.error)
				.finally(() => setSaving(false));
		},
		[getSelectedSSTemplates, onCancel, onSave, task]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={`Associate - ${task.title}`}
			onCancel={onCancel}
			closable={false}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					Save
				</Button>,
			]}
		>
			<Form id={FORM_NAME} layout="vertical" onFinish={onSubmit} initialValues={{ ...task }}>
				<Form.Item
					name="siteSurveyTemplateIds"
					label="Site Survey Template"
					rules={[{ required: true, message: 'Please select a site survey template.' }]}
				>
					<OWAsyncSelect
						mode="multiple"
						style={{ maxWidth: 640 }}
						targetCollectionName={WO_TASK_COLLECTION}
						stateSlice={siteSurveyTemplates}
						fetchMultiple={(ids, targetCollectionName) => {}}
						fetchData={(search, targetCollectionName) => {
							getSiteSurveyTemplates({ search }, targetCollectionName);
						}}
						renderRecord={(ss) => (
							<Select.Option key={ss.id} value={ss.id}>
								{ss.title}
							</Select.Option>
						)}
						sortBy={{ sort_by: 'name', order: 'ascend' }}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	siteSurveyTemplates: state.site_survey_templates,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurveyTemplates: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveyTemplatesRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: siteSurveyTemplatesRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const TaskEntityAssociateModalWUT = connect(
	mapStateToProps,
	mapDispatchToProps
)(PMTemplateTaskEntityAssociateModal);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(TaskEntityAssociateModalWUT);
